
//Embedded PDF GTM Event Start
$('.pdfbtn').on("click", function (e) {
    e.preventDefault();
    var eleClass = $(this).attr("class");
    var parentele = event.srcElement.closest('.ld-pdfrender');
    var assetTitle = parentele.getAttribute('data-gtmdocumenttitle');
    var buType = parentele.getAttribute('data-gtmbusinessline');
    var eventAction = "Library PDF Preview";
    if (eleClass.includes("zoomctrl")) { eventAction = "Library PDF Zoom"; }
    var gtmData = {
        'event': 'gaCustomEvents_PDF_interactions',
        'eventCategory': 'Customer Enablement & Education',
        'eventAction': eventAction,
        'eventLabel': parentele.getAttribute('data-gtmassetid'),
        'document_title': assetTitle,
    };
    GTMDatalayerPush(gtmData, buType, assetTitle)
});

var scrollTwentyFiveV = true,
    scrollFiftyV = true,
    scrollSeventyFiveV = true,
    scrollNightyV = true,
    scrollTwentyFiveH = true,
    scrollFiftyH = true,
    scrollSeventyFiveH = true,
    scrollNightyH = true;
function embeddedPDFScrollCtrlGTM() {
    var ele = event.srcElement;
    var parentele = event.srcElement.closest('.ld-pdfrender');
    var scrollV = (ele.scrollTop / (parentele.clientHeight - ele.clientHeight)) * 10;
    var scrollH = (ele.scrollLeft / (parentele.clientWidth - ele.clientWidth)) * 10;
    var assetTitle = parentele.getAttribute('data-gtmdocumenttitle');
    var buType = parentele.getAttribute('data-gtmbusinessline');
    var gtmData = {
        'event': 'gaCustomEvents_PDF_interactions',
        'eventCategory': 'Customer Enablement & Education',
        'eventAction': 'Library PDF Scroll',
        'eventLabel': parentele.getAttribute('data-gtmassetid'),
        'document_title': assetTitle,
    };
    // Conditional code we'll use to fire events based on scrollPercentage vertical.
    if (scrollV >= 25 && scrollTwentyFiveV) {
        // Do something for 25% scroll
        scrollTwentyFiveV = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollV >= 50 && scrollFiftyV) {
        // Do something for 50% scroll
        scrollFiftyV = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollV >= 75 && scrollSeventyFiveV) {
        // Do something for 75% scroll
        scrollSeventyFiveV = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollV >= 90 && scrollNightyV) {
        // Do something for 90% scroll (bottom of page)
        scrollNightyV = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    //Conditional code we'll use to fire events based on scrollPercentage Horizontal.
    if (scrollH >= 25 && scrollTwentyFiveH) {
        // Do something for 25% scroll
        scrollTwentyFiveH = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollH >= 50 && scrollFiftyH) {
        // Do something for 50% scroll
        scrollFiftyH = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollH >= 75 && scrollSeventyFiveH) {
        // Do something for 75% scroll
        scrollSeventyFiveH = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
    if (scrollH >= 90 && scrollNightyH) {
        // Do something for 90% scroll (bottom of page)
        scrollNightyH = false;
        GTMDatalayerPush(gtmData, buType, assetTitle)
    }
}

////Distributor GTM Event for External link Start
function GTMDistributorDetailsExternalMapClick(link) {
    var gtmDistributorExternalLink = {
        "componentId": "sp01",
        "componentName": "map",
        "elementType": "locator map",
        "event": "locator",
        "eventType": "map pin click",
        "searchSubType": "",
        "searchTerm": "",
        "searchType": "",
        'event1': 'gaCustomEvents_distributor_locator',
        'eventCategory': 'Customer Enablement & Education',
        'eventAction': 'Visited Distributor Site',
        'eventLabel': link,
        'external_url': link,
        'page_type': 'Distributor Page',
        'page_title': 'Distributor Locator',
        'page_bu': pageVariables.BusinessUnit,
        'environment': pageVariables.Environment,
        'page_language': pageVariables.SiteLanguage,
        'sitecore_contact_id': pageVariables.SitecoreContactId,
        'pardot_cookie_id': pageVariables.PardotCookieId
    };
   dataLayer.push(gtmDistributorExternalLink);
}

// Common Parameters for all GTM Event Start
function GTMDatalayerPush(GTMDynamicData, buType, assetTitle) {

    if (typeof buType === "undefined") {
        var GTMPageBU = pageVariables.BusinessUnit;
    }
    else {
        var GTMPageBU = buType;
    }
    if (typeof assetTitle === "undefined") {
        var GTMPageTitle = pageVariables.PageTitle;
    }
    else {
        var GTMPageTitle = assetTitle;
    }

    var GTMCommonData = {
        'page_type': pageVariables.PageCategory,
        'page_title': GTMPageTitle,
        'page_bu': GTMPageBU,
        'environment': pageVariables.Environment,
        'page_language': pageVariables.SiteLanguage,
        'sitecore_contact_id': pageVariables.SitecoreContactId,
        'pardot_cookie_id': pageVariables.PardotCookieId
    };

    var GTMData = $.extend(GTMDynamicData, GTMCommonData);
    dataLayer.push(GTMData);
}

// Returns the assetID for EventLabel property for Library Asset downloads
function GetLibraryAssetIdForDownloadEvent(hrefAttr) {
    var assetId = undefined;
    if (hrefAttr.split(/[\s/]+/)[3]) {
        assetId = hrefAttr.split(/[\s/]+/)[3];
        if (assetId.split('-')[0]) {
            assetId = assetId.split('-')[0]
        }
    }
    return assetId;
}


function encodeTextareaValue(txtelement) {
    var txtval = txtelement.val();
    var utf16 = [];
    if (txtval != "" && txtval != undefined) {
        for (var i = 0, strLen = txtval.length; i < strLen; i++) {
            utf16.push(('000' + (parseInt(txtval.charCodeAt(i), 10).toString(16))).slice(-4));
        }
        txtelement.val(utf16.join("u"));
    }
}


// Changing decode code to decode chinese, english and spanish fonts
function decodeTextareaValue(txtareaelement) {
    if (txtareaelement != undefined) {
        var textareaval = txtareaelement.val();
        if (textareaval != "" && textareaval != undefined) {
            var textArr = textareaval.split("u");
            var decodedText = "";
            if (textArr != undefined) {
                for (var i = 0; i < textArr.length; i++) {
                    var hexValue = textArr[i];
                    if (hexValue !== "") {
                        var charCode = parseInt(hexValue, 16);
                        decodedText += String.fromCharCode(charCode);
                    }
                }
                txtareaelement.val(decodedText);
            }
        }
    }
}

function checkUndefined(value) {
    if (typeof value === "undefined") {
        value = "";
    }
    return value;
}

